/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';
import {
  sideNavStyle,
  brandStyle,
  navStyle,
  navItemStyle,
  footerStyle,
  statusDotStyle,
} from './SideNav.styles';

export interface SideNavItem {
  id: string;
  icon?: ReactNode;
  label: ReactNode;
}

export interface SideNavProps {
  title: ReactNode;
  subtitle?: ReactNode;
  items: SideNavItem[];
  activeId: string;
  onSelect: (id: string) => void;
  /** 하단 상태 문구. 예: "스케줄러 가동 중" */
  statusText?: ReactNode;
  /** 상태 아래 부가 정보. 예: "틱 주기 1분 · v0.1" */
  metaText?: ReactNode;
}

/** 좌측 내비게이션. 대시보드·모듈 관리·수집 이력·데이터 브라우저 전환에 활용. */
export function SideNav({ title, subtitle, items, activeId, onSelect, statusText, metaText }: SideNavProps) {
  return (
    <aside css={sideNavStyle}>
      <div css={brandStyle}>
        <div>{title}</div>
        {subtitle !== undefined && <p>{subtitle}</p>}
      </div>
      <nav css={navStyle}>
        {items.map((item) => (
          <button
            key={item.id}
            type="button"
            css={navItemStyle(item.id === activeId)}
            onClick={() => onSelect(item.id)}
          >
            {item.icon !== undefined && <span>{item.icon}</span>}
            {item.label}
          </button>
        ))}
      </nav>
      <div css={footerStyle}>
        {statusText !== undefined && (
          <div>
            <span css={statusDotStyle} /> {statusText}
          </div>
        )}
        {metaText !== undefined && <p>{metaText}</p>}
      </div>
    </aside>
  );
}
